import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { filter, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { MessageService } from './message.service';

@Injectable()
export class LookupTypeService extends BaseService {
	responseResults: any[] = [];

	constructor(private http: HttpClient,  private _messageService: MessageService, private _router: Router) {
		super();
	}

	public getCacheableEnumeratedList(listTypeName: string) {

		var cachedList = localStorage.getItem(listTypeName + 'List');

		if(cachedList !== undefined && cachedList != null) {
			return Observable.create(function (subscriber: any) {
				subscriber.next(JSON.parse(cachedList));
				subscriber.complete();
			});
		} else if(listTypeName.toLowerCase().indexOf('vehicle') == 0) {
			var reqUri = environment.commonApiUrl + 'vehiclemake/get' + listTypeName.toLowerCase() + 'slist';

			return this.http.get<any>(reqUri, this.httpBaseOptions).pipe(map((response: any) => {
				this.responseResults = response;
				localStorage.setItem(listTypeName + 'List', JSON.stringify(this.responseResults));
				return this.responseResults;
			}));
		} else {
			var reqUri = environment.commonApiUrl + 'lookupitem/getparametertypes?listtype=' + this.cleanseUrlParam(listTypeName);

			return this.http.get<any>(reqUri, this.httpBaseOptions).pipe(map((response: any) => {
				this.responseResults = response;
				localStorage.setItem(listTypeName + 'List', JSON.stringify(this.responseResults));
				return this.responseResults;
			}));
		}
	}
}